import { render, staticRenderFns } from "./IconSpinMinus.vue?vue&type=template&id=024c910b&"
import script from "./IconSpinMinus.vue?vue&type=script&lang=js&"
export * from "./IconSpinMinus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports